import { HibooLogoLarge } from 'modules/common-ui';
import type { PropsWithChildren } from 'react';

import { AuthLayoutCSS } from './AuthLayout.css';

const { CardWrapper, LogoBar, Wrapper } = AuthLayoutCSS;

export const AuthLayout = ({ children }: PropsWithChildren) => {
  return (
    <Wrapper>
      <LogoBar>
        <HibooLogoLarge />
      </LogoBar>
      <CardWrapper>{children}</CardWrapper>
    </Wrapper>
  );
};
